/**
 * Citations do not always arrive as absolute URLs — grounding metadata
 * sometimes hands back a bare `example.com`. Rendering that straight into an
 * `href` makes the browser resolve it against the current page, so the link
 * silently points at `/ai-visibility-scan/example.com` and 404s.
 */

/** Hostname for display, or the input unchanged when it is already a bare host. */
export function hostOf(u: string): string {
  try {
    return new URL(u).hostname.replace(/^www\./, '');
  } catch {
    return u.replace(/^www\./, '').split('/')[0] ?? u;
  }
}

/** An href that always leaves this site. Never returns a relative path. */
export function externalHref(u: string): string {
  const t = u.trim();
  if (/^https?:\/\//i.test(t)) return t;
  if (/^\/\//.test(t)) return `https:${t}`;
  return `https://${t.replace(/^\/+/, '')}`;
}
